export const SUCCESS_CODE = 200;
export const CREATED_CODE = 201;
export const NO_CONTENT = 204;
export const VALIDATION_FAIL_CODE = 400;
export const AUTHENTICATION_FAIL_CODE = 401;
export const NOT_ALLOW_CODE = 403;
export const NOT_FOUND_CODE = 404;
export const ERROR_EXCEPTION_CODE = 500;
export const ERROR_EMAIL_CONFLICT = 422;

export const SUCCESS_STATUS_MESSAGE = "OK";
export const ERROR_STATUS_MESSAGE = "NG";
